import { EventEmitter, Injectable, Output } from '@angular/core';

import { StatusMonitorService, StatusMonitorUpdate } from './status-monitor.service';

@Injectable()
export class StatusHistoryService {
  private readonly maxPoints = 12;
  private readonly _data = new Array<StatusMonitorUpdate>();

  @Output() readonly updated = new EventEmitter();
  @Output() get data(): Array<StatusMonitorUpdate> {
    return this._data;
  }

  constructor(private statusMonitor: StatusMonitorService) {
    this.statusMonitor.updated.subscribe(($event: StatusMonitorUpdate) => {
      if (this._data.length >= this.maxPoints) {
        this._data.shift();
      }
      this._data.push($event);

      this.updated.emit(this.data);
    });
  }

}



// WEBPACK FOOTER //
// /builds/iws/vanenet/src/app/main/services/status-history.service.ts